export const generateAnalyticsEvents = ({ name, customTaggingEvent, }) => {
    const handle = (isOpen) => {
        if (customTaggingEvent !== undefined) {
            customTaggingEvent(name, isOpen);
        }
    };
    return {
        onOpen: () => {
            handle(true);
        },
        onClose: () => {
            handle(false);
        },
    };
};
